import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { ISalesRep, ISalesRepCallGoal, SalesRepActionTypes } from '.';
import { uniqObjectMerge } from '../../utils/arrayUtils';

export interface ISalesRepState {
  callGoals: ISalesRepCallGoal[];
  salesReps: Record<string, ISalesRep>;
}

const initState: ISalesRepState = {
  callGoals: [],
  salesReps: {}
};

export function salesRepReducer(state: ISalesRepState = initState, action: SalesRepActionTypes): ISalesRepState {
  switch (action.type) {
    case 'REMOVE_SALES_REP':
      return {
        ...state,
        salesReps: omit(state.salesReps, action.payload.sid)
      };
    case 'SET_SALES_REPS':
      return {
        ...state,
        salesReps: {
          ...state.salesReps,
          ...keyBy<ISalesRep>(action.payload, x => x.sid)
        }
      };
    case 'SET_SALES_REP_CALL_GOALS':
      return {
        ...state,
        callGoals: uniqObjectMerge(state.callGoals, action.payload, x => `${x.fiscalYear}_${x.sid}`)
      };
    default:
      return state;
  }
}
